import type { IconProps } from './types';

export function Colete({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 60 Q88 56 100 60 Q116 88 128 116 Q140 88 156 60 Q168 56 180 60 Q188 64 188 76 L188 204 Q188 216 176 216 L80 216 Q68 216 68 204 L68 76 Q68 64 76 60 Z" />
    </svg>
  );
}
